module.exports = __webpack_public_path__ + "img/write.2336eb53.svg";